import { render, staticRenderFns } from "./DictionaryInProgress.vue?vue&type=template&id=6a46c096&"
import script from "./DictionaryInProgress.vue?vue&type=script&lang=js&"
export * from "./DictionaryInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports